import React from 'react'


export default class Loading extends React.Component {
  render() {
    return (
      <div style={{
        width: '100',
        minHeight: '50rem',
      }}>
        Loading...
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading.jsx